var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "12"
    }
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_c('strong', [_vm._v("Selected Activity")])]), _c('div', {
    staticClass: "d-flex overflow-auto"
  }, [_c('table', {
    staticClass: "table table-sm",
    attrs: {
      "size": "sm"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-truncate"
  }, [_c('th', {
    staticClass: "sticky-col text-center",
    staticStyle: {
      "width": "5px"
    }
  }, [_vm._v("#")]), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5px"
    }
  }, [_vm._v("End Trip")]), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Fleet")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Start Date")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("End Date")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Current Position")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Port Loading")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Port Discharge")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Agent POL")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Agent POD")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("PIC / PE")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Departure")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Updated Today")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Reason")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Remarks")]), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Document on Board")]), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Cargo Loading")]), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Cargo Unloading")])])]), _vm.assign.length > 0 ? _c('tbody', _vm._l(_vm.assign, function (val, index) {
    var _val$reason, _val$reason2, _Number, _Number2;
    return _c('tr', {
      key: index,
      staticClass: "text-truncate",
      staticStyle: {
        "min-width": "200px"
      }
    }, [_c('td', {
      staticClass: "sticky-col text-center",
      staticStyle: {
        "width": "5px",
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.assign.splice(index, 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]), _c('td', {
      staticClass: "text-center"
    }, [(val === null || val === void 0 ? void 0 : (_val$reason = val.reason) === null || _val$reason === void 0 ? void 0 : _val$reason.name) === 'Unloading' ? _c('b-form-checkbox', {
      attrs: {
        "name": "check-button",
        "switch": "",
        "inline": "",
        "checked": val.isEndTrip
      },
      on: {
        "change": function change($event) {
          return _vm.setOnlyOneIsEndTrip(index);
        }
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "text-truncate text-left"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm._l(val.vehicle, function (v, v_index) {
      return _c('span', {
        key: "h-v-".concat(v_index),
        staticClass: "fs-5 mb-1"
      }, [_c('b-badge', {
        attrs: {
          "variant": "success"
        }
      }, [_vm._v(_vm._s(v === null || v === void 0 ? void 0 : v.name))])], 1);
    }), _c('b-badge', {
      staticClass: "mb-1",
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(_vm.formatString(val === null || val === void 0 ? void 0 : val.voyageType)))])], 2)]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.startDate ? _vm.moment(val.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.endDate ? _vm.moment(val.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val.currentPosition))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val.portLoading.portName))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val.portDischarge.portName))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val.agentPol))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val.agentPod))]), _c('td', [_c('div', {
      staticClass: "d-flex flex-column"
    }, _vm._l(val.pic, function (v, v_index) {
      return _c('span', {
        key: "h-v-".concat(v_index),
        staticClass: "fs-5 mb-1"
      }, [_c('b-badge', {
        attrs: {
          "variant": "info"
        }
      }, [_vm._v(_vm._s(v === null || v === void 0 ? void 0 : v.name))])], 1);
    }), 0)]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.podDeparture ? _vm.moment(val.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(_vm.moment().format('DD MMM YYYY HH:mm')) + " ")]), _c('td', [_vm._v(_vm._s((val === null || val === void 0 ? void 0 : (_val$reason2 = val.reason) === null || _val$reason2 === void 0 ? void 0 : _val$reason2.name) || '-'))]), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(val.remark))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.polDocOnBoard ? _vm.moment(val.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((_Number = Number((val === null || val === void 0 ? void 0 : val.cargoLoading) || 0)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString()))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s((_Number2 = Number((val === null || val === void 0 ? void 0 : val.cargoUnloading) || 0)) === null || _Number2 === void 0 ? void 0 : _Number2.toLocaleString()))])]);
  }), 0) : _c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "17"
    }
  }, [_vm._v("No Selected Activity List.")])])])])])]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_c('strong', [_vm._v("Assign to Trip")])]), _c('div', {
    staticClass: "d-flex overflow-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-truncate"
  }, [_c('th', {
    staticClass: "sticky-col text-center"
  }, [_vm._v("#")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Trip Info")]), _c('th', [_vm._v("Start Date")]), _c('th', [_vm._v("End Date")]), _c('th', [_vm._v("Project")]), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("POL Remark")]), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v("POD Remark")])])]), _vm.unfinishedTrip.length > 0 ? _c('tbody', _vm._l(_vm.unfinishedTrip, function (val, index) {
    var _val$portLoading, _val$portDischarge, _val$subProject;
    return _c('tr', {
      key: index,
      staticClass: "cursor-pointer"
    }, [_c('td', {
      staticClass: "sticky-col text-center"
    }, [_c('b-form-checkbox', {
      attrs: {
        "name": "check-button",
        "switch": "",
        "inline": ""
      },
      on: {
        "change": function change($event) {
          return _vm.setChecked(index);
        }
      },
      model: {
        value: val.checked,
        callback: function callback($$v) {
          _vm.$set(val, "checked", $$v);
        },
        expression: "val.checked"
      }
    })], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "d-flex align-items-center text-primary"
    }, [_c('i', {
      staticClass: "fas fa-map-pin mr-2"
    }), _vm._v(" " + _vm._s((val === null || val === void 0 ? void 0 : (_val$portLoading = val.portLoading) === null || _val$portLoading === void 0 ? void 0 : _val$portLoading.portName) || (val === null || val === void 0 ? void 0 : val.portLoadingOther)) + " ")]), _c('div', {
      staticClass: "dashed-border"
    }), _c('div', {
      staticClass: "d-flex align-items-center text-primary"
    }, [_c('i', {
      staticClass: "fa fa-map-pin mr-2"
    }), _vm._v(" " + _vm._s((val === null || val === void 0 ? void 0 : (_val$portDischarge = val.portDischarge) === null || _val$portDischarge === void 0 ? void 0 : _val$portDischarge.portName) || (val === null || val === void 0 ? void 0 : val.portDischargeOther)) + " ")])])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.startDate ? _vm.moment(val.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(val.endDate ? _vm.moment(val.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(val.subProject.project.projectName) + " - " + _vm._s(val === null || val === void 0 ? void 0 : (_val$subProject = val.subProject) === null || _val$subProject === void 0 ? void 0 : _val$subProject.name))]), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(val.polRemark))]), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(val.podRemark))])]);
  }), 0) : _c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No Assign Trip List.")])])])])])]), _vm.unfinishedTrip.length > 0 && _vm.assign.length > 0 ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary btn-menu mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.closeSidebar('assign-trip');
      }
    }
  }, [_vm._v(" Cancel & Close ")]), _c('button', {
    staticClass: "btn btn-primary btn-menu",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSaveAssignTrip
    }
  }, [_vm._v(" Assign & Submit ")])])]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }